<template>
  <div>
    <header class="header flex-box">
      <div @click="back" class="flex1 flex-box flex-v-c"> <i class="iconfont icon-houtui"></i> 返回</div>
      <div class="headerTitle flex1 flex-box flex-hv-c">{{this.$store.state.currentTitle.title}}</div>
      <div @click="home" class="home flex1 flex-box flex-h-e flex-v-c"><i class="iconfont icon-home"></i></div>
    </header>
  </div>
</template>
<!--javascript-->
<script>
  export default{
    data: function () {
      return {
      }
    },
    methods: {
      back(){
        history.go(-1)
      },
      home(){
        this.$router.push('/home')
      }
    },
    mounted: function () {
    },
    created: function () {
    }
  }
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/common/header.vue